import { useQueryClient } from "@tanstack/react-query";
import { useAppContext } from "../providers/AppProvider";

export function useInvalidateUserDocuments() {
  const {
    plan: { deceasedUser },
  } = useAppContext();
  const queryClient = useQueryClient();
  return () => {
    // Invalidate both userDocuments and allUserDocuments queries
    queryClient.invalidateQueries({
      queryKey: ["userDocuments", deceasedUser?.id],
      exact: false,
    });
    queryClient.invalidateQueries({
      queryKey: ["allUserDocuments", deceasedUser?.id],
      exact: false,
    });
  };
}
